import v2 from './v2'
import axios from '@axios'

export default {
    namespaced: true,
    state: {
        codigosDivisiones: [],
        registrosIngresados: [],
        cronometroProv:[],
        HistorialCajaChica:[],
        ordenPago: [],
        tiposDocumentosE: [],
        Anticipos: [],
        PendientesAprobacion: [],
        NivelAprobacionAnticipos: [],
    },
    getters: {
        getCodigosDivisiones(state) {
            return state.codigosDivisiones
        },
        getRegistrosIngresados(state) {
            return state.registrosIngresados
        },
        getcronometroProv(state) {
            return state.cronometroProv
        },
        getHistorialCajaChica(state){
            return state.HistorialCajaChica
        },
        getOrdenPago(state) {
            return state.ordenPago
        },
        getTipoDocumentoE(state) {
            return state.tiposDocumentosE
        },
        getAnticipos(state) {
            return state.Anticipos
        },
        getPendientesAprobacion(state) {
            return state.PendientesAprobacion
        },
        getNivelAprobacionAnticipos(state) {
            return state.NivelAprobacionAnticipos
        },
    },
    mutations: {
        setCodigosDivisiones(state, codigosDivisiones) {
            state.codigosDivisiones = codigosDivisiones
        },
        setRegistrosIngresados(state, registrosIngresados) {
            state.registrosIngresados = registrosIngresados
        },
        setCronometro(state, cronometroProv) {
            state.cronometroProv = cronometroProv
        },
        setCajaChica(state, HistorialCajaChica) {
            state.HistorialCajaChica = HistorialCajaChica
        },
    },
    actions: {
        fetchCargarCodigosDivisiones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/cuentasxpagar/CodigosDivision')
                    .then(response => {
                        commit('setCodigosDivisiones', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchBuscarRegistrosPDF({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/cuentasxpagar/RegistrosPDF', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchBuscarRegistrosXLSX({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cuentasxpagar/RegistrosXLSX', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCronometroProvisiones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/cuentasxpagar/reporteCronometroProvisiones', data)
                    .then(response => {
                        commit('setCronometro', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchModicaProvisiones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/cuentasxpagar/reporteModificaProvisiones', data)
                    .then(response => {
                        commit('setCronometro', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchHistorialCajaChica({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/cuentasxpagar/reporteHistorialCajaChica', data)
                    .then(response => {
                        commit('setCajaChica', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },



    },
    modules: {
        v2,
    },
}
